/*
 * Custom JavaScript
 * 1. Affiche le code de bienvenue une fois l'inscription à la newsletter réussie
 *    (formulaire de la page d'accueil et du pied de page).
 * 2. Lien « -10 % » de la barre d'annonce : fait défiler jusqu'au formulaire e-mail
 *    de la page d'accueil (ou y mène depuis les autres pages).
 * 3. Fiche produit : retire de la description le bloc « Livraison et retours »,
 *    déjà affiché dans l'onglet « Livraison & Retours » de la page.
 */
(function () {
  var CODE = 'BIENVENUE10';
  var HASH = '#newsletter-welcome';

  function showWelcomeCode() {
    document.querySelectorAll('.newsletter-form__message--success').forEach(function (msg) {
      if (msg.getAttribute('data-welcome-code')) return;
      msg.setAttribute('data-welcome-code', '1');
      var box = document.createElement('p');
      box.className = 'welcome-code';
      box.innerHTML = 'Votre code de bienvenue : <strong class="welcome-code__value">' + CODE + '</strong><br>10 % de réduction sur votre première commande, à saisir au moment du paiement.';
      msg.insertAdjacentElement('afterend', box);
    });
  }

  function scrollToNewsletter() {
    var el = document.querySelector('[id$="__newsletter_welcome"]');
    if (!el) return false;
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return true;
  }

  function removeDuplicateShipping() {
    document.querySelectorAll('.product__description, .collapsible__description').forEach(function (box) {
      box.querySelectorAll('h3').forEach(function (heading) {
        if (heading.textContent.trim().toLowerCase() !== 'livraison et retours') return;
        var next = heading.nextElementSibling;
        while (next && next.tagName !== 'H3') {
          var following = next.nextElementSibling;
          next.remove();
          next = following;
        }
        heading.remove();
      });
    });
  }

  function init() {
    showWelcomeCode();
    removeDuplicateShipping();
    var main = document.querySelector('main');
    if (main && 'MutationObserver' in window) {
      new MutationObserver(removeDuplicateShipping).observe(main, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.location.hash === HASH) {
    window.addEventListener('load', scrollToNewsletter);
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('a[href$="' + HASH + '"]') : null;
    if (!link) return;
    if (window.location.pathname === '/' && scrollToNewsletter()) {
      e.preventDefault();
    }
  }, true);
})();